export class GameRulesEvents {
    public static readonly OPENED: string = 'GAME_RULES_OPENED';
    public static readonly CLOSED: string = 'GAME_RULES_CLOSED';
}